module.exports = __webpack_public_path__ + "static/media/jieqiabiaozhun61.5fa4f872.png";